<div class="mart-order-details-title">Xpress Transaction</div>

<div class="flex-row">
    <!-- Left column of Xpress Transaction -->
    <div class="filler">
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Order date:</div>
            <div class="mart-order-details-field-val">{{parent.orderDateStr}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Order time:</div>
            <div class="mart-order-details-field-val">{{parent.orderTimeStr}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Order type:</div>
            <div class="mart-order-details-field-val"></div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Promo:</div>
            <div class="mart-order-details-field-val">{{parent.order.PromoName}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Promo Funded:</div>
            <div class="mart-order-details-field-val">Partner Funded</div>
        </div>
    </div>

    <!-- Right column of Xpress Transaction -->
    <div class="filler">
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-right-field-name">Payment method:</div>
            <div class="mart-order-details-field-val">{{parent.order.PaymentMethod}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-right-field-name">Order amount:</div>
            <div class="mart-order-details-field-val">₱ {{parent.order.TotalPrice}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-right-field-name">Deductions:</div>
            <div class="mart-order-details-field-val"></div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-right-field-name">Payment amount:</div>
            <div class="mart-order-details-field-val">₱ {{parent.order.PaymentAmount}}</div>
        </div>
    </div>
</div>

<div class="mart-order-details-title" style="margin-top: 30px;">Delivery Details</div>

<div class="flex-row">
    <!-- Left column of Delivery Details -->
    <div class="filler">
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Delivery type:</div>
            <div class="mart-order-details-field-val">{{parent.order.DeliveryType}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Delivery created:</div>
            <div class="mart-order-details-field-val">{{parent.deliveryCreatedTimeStr}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Delivery date:</div>
            <div class="mart-order-details-field-val">{{parent.deliveryCompletedDateStr}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-left-field-name">Delivery time:</div>
            <div class="mart-order-details-field-val">{{parent.deliveryCompletedTimeStr}}</div>
        </div>
    </div>

    <!-- Right column of Delivery Details -->
    <div class="filler">
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-right-field-name">Delivery partner:</div>
            <div class="mart-order-details-field-val">{{parent.order.DeliveryService}}</div>
        </div>
        <div class="flex-row">
            <div class="mart-order-details-field-name mart-order-details-info-right-field-name">Delivery driver:</div>
            <div class="mart-order-details-field-val">{{parent.order.RiderName}}</div>
        </div>
    </div>
</div>

<div class="flex-row" style="margin-top: 20px;">
    <div class="filler">
        <div class="mart-order-details-title">Dispatch Slip Signature</div>
        <img style="max-width: 300px;" src="{{parent.order.DispatchPhotoUrl}}" />
    </div>
    <div class="filler">
        <div class="mart-order-details-title">Customer Signature</div>
        <img style="max-width: 300px;" src="{{parent.order.DropSignatureImageUrl}}" />
    </div>
</div>

